enum actionTypes {
    MODAL_APROVAR_EXTRATO_OPEN = 'MODAL_APROVAR_EXTRATO_OPEN',
    MODAL_APROVAR_EXTRATO_CLOSE = 'MODAL_APROVAR_EXTRATO_CLOSE',
    MODAL_ANEXAR_NOTA_FISCAL_OPEN = 'MODAL_ANEXAR_NOTA_FISCAL_OPEN',
    MODAL_ANEXAR_NOTA_FISCAL_CLOSE = 'MODAL_ANEXAR_NOTA_FISCAL_CLOSE',
}

export default actionTypes;
